import * as Sentry from "@sentry/react";
import { useEffect } from "react";

interface Props {
  error: Error;
  reset?: () => void;
}

export function SentryErrorBoundary({ error, reset }: Props) {
  useEffect(() => {
    console.error("Sentry Error Boundary caught:", error);
    Sentry.captureException(error);
  }, [error]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center p-4 text-center">
      <h1 className="text-2xl font-bold text-destructive">
        Something went wrong
      </h1>
      <p className="mt-2 text-muted-foreground max-w-md">
        {error?.message ||
          "An unexpected error occurred. We've been notified and are looking into it."}
      </p>
      <div className="mt-6 flex gap-4">
        <button
          type="button"
          onClick={() => window.location.assign("/")}
          className="rounded-md bg-primary px-4 py-2 text-primary-foreground hover:bg-primary/90 transition-colors"
        >
          Go Home
        </button>
        {reset && (
          <button
            type="button"
            onClick={reset}
            className="rounded-md border border-input bg-background px-4 py-2 hover:bg-accent hover:text-accent-foreground transition-colors"
          >
            Try Again
          </button>
        )}
      </div>
    </div>
  );
}
